import { useState } from "react";
import { Hero } from "./app/Hero";
import { Workbench } from "./app/Workbench";
import { HowItWorks } from "./app/HowItWorks";
import { CaseStudy } from "./app/CaseStudy";
import "./App.css";

export function App() {
  const [sessionKey, setSessionKey] = useState(0);

  return (
    <>
      <a href="#workbench" className="skip-link">
        Saltar al workbench
      </a>
      <Hero onDeleteSession={() => setSessionKey((key) => key + 1)} />
      <main id="main-content">
        <Workbench key={sessionKey} />
        <HowItWorks />
        <CaseStudy />
      </main>
      <footer className="app-footer">
        <p>
          MCP App UI Kit · Modo determinista · Ningún dato sale de tu navegador ·{" "}
          <a href="https://github.com/Aredex/mcp-app-ui-kit">Código fuente</a>
        </p>
      </footer>
    </>
  );
}
